import Avatar from './variants/Avatar';
import UploadAvatar from './variants/UploadAvatar';
export * from './types';
export { Avatar, UploadAvatar };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/avatar/dist/esm/index.js
// module id = 5574
// module chunks = 11